<page-loader *ngIf="!isLoaded"></page-loader>
<div
    id="page-as-details"
    class="app-c-modal--secondary"
    role="dialog"
    aria-labelledby="modalTitle"
    aria-modal="true">
    <!-- <page-header [cssClass]="'activityscheduler'" [headerText]="title" [backText]="backText" [backLink]='backLink' [headerImage]="'./assets/img/icons/activity_scheduler@2x.png'"></page-header> -->

    <div class="app-c-modal-secondary__header" *ngIf="isLoaded">
        <div class="app-c-modal-secondary__header-left">
            <!-- Accessible dynamic heading with ID -->
            <h3
                class="app-c-heading--h3"
                *ngIf="!activityId"
                id="modalTitle"
                translate>
                as.add
            </h3>
            <h3
                class="app-c-heading--h3"
                *ngIf="activityId"
                id="modalTitle"
                translate>
                as.edit
            </h3>
        </div>

        <div class="app-c-modal-secondary__header-right">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-14"
                (click)="cancel()"
                type="button"
                aria-label="Close dialog">
                <svg-icon icon="close" class="w-100 h-100"></svg-icon>
            </button>
        </div>
    </div>

    <div
        class="app-c-modal-secondary__body"
        role="document"
        aria-labelledby="activity-modal-title"
        aria-describedby="activity-modal-desc">
        <div class="app-l-select-type" *ngIf="!activityId">
            <h4 class="app-c-heading--h4" id="activity-modal-title" translate>
                as.selectType
            </h4>
            <div class="app-l-select__controls">
                <button
                    [disabled]="isDisabled"
                    class="app-c-btn app-c-btn--tertiary"
                    *ngFor="let config of configListing"
                    (click)="selectType(config.Value)"
                    [ngClass]="{ active: isType(config.Value) }"
                    [attr.aria-pressed]="isType(config.Value)"
                    type="button">
                    <span translate>{{ config.Key }}</span>
                </button>
            </div>
        </div>

        <div
            *ngIf="!activityType && !activityId"
            class="app-l-no-mood-check"
            id="activity-modal-desc">
            <div class="no-data-image" role="img" aria-label="No mood data">
                <svg-icon icon="room-for-positive"></svg-icon>
                <span class="app-l-no-mood__round app-l-no-mood__round1"></span>
                <span class="app-l-no-mood__round app-l-no-mood__round2"></span>
                <span class="app-l-no-mood__round app-l-no-mood__round3"></span>
            </div>
            <p class="app-c-body-text--14">
                Choose an activity type to select an activity
            </p>
        </div>

        <div
            *ngIf="activityType && !activityId"
            class="app-l-select__activity"
            aria-label="Sub activity section">
            <h4 class="app-c-heading--h4" translate id="select">
                as.selectType
            </h4>
            <div class="app-l-select__activity-controls" tabindex="0">
                <button
                    #subActivityButton
                    [disabled]="isDisabled"
                    type="button"
                    class="app-c-btn app-l-select__activity-controls-button app-c-btn--curve app-c-btn--sm focus-ring"
                    *ngFor="let activity of activities"
                    (click)="toggleOption(activity)"
                    [ngClass]="{ activeActivity: activity.isSelected }"
                    [attr.aria-pressed]="activity.isSelected">
                    <span translate>{{ activity.Value }}</span>
                </button>
            </div>
        </div>

        <div
            class="app-l-select__new-activity"
            *ngIf="activityType && !activityId">
            <button
                class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                (click)="onAddCustomOption()"
                aria-label="Add new custom activity"
                type="button">
                <svg-icon icon="plus"></svg-icon>
                <span translate>select.add</span>
            </button>
        </div>

        <div class="app-l-select__schedule" *ngIf="!activityId">
            <h4 class="app-c-heading--h4" translate>Schedule</h4>
            <div class="app-l-ss__row" [ngClass]="{ disable: !activityType }">
                <div class="app-l-ss__blocks">
                    <!-- Start Date -->
                    <div class="app-l-ss__block">
                        <label
                            for="startDateInput"
                            aria-label="Select start date"
                            class="app-c-body-text--14-m">
                            Start Date</label
                        >
                        <div class="app-c-datepicker app-c-form-group">
                            <input
                                id="startDateInput"
                                class="app-c-form-control"
                                type="text"
                                placeholder="Start Date"
                                [owlDateTime]="dt1"
                                [owlDateTimeTrigger]="dt1"
                                [(ngModel)]="start"
                                [min]="minDate"
                                (ngModelChange)="changeStartDateTime($event)"
                                aria-label="Select start date"
                                role="textbox"
                                aria-haspopup="dialog"
                                aria-controls="dt1"
                                tabindex="-1" />
                            <div
                                class="app-c-datepicker__icon"
                                tabindex="0"
                                role="button"
                                aria-label="Open calendar"
                                (click)="dt1.open()"
                                (keydown.enter)="dt1.open()"
                                (keydown.space)="dt1.open()">
                                <svg-icon
                                    icon="calendar"
                                    aria-hidden="true"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'calendar'"
                                #dt1></owl-date-time>
                        </div>
                    </div>

                    <!-- Start Time -->
                    <div class="app-l-ss__block">
                        <label
                            for="startTimeInput"
                            aria-label="Select start time"
                            class="app-c-body-text--14-m">
                            Start Time</label
                        >
                        <div class="app-c-timepicker app-c-form-group">
                            <input
                                id="startTimeInput"
                                class="app-c-form-control"
                                type="text"
                                placeholder="Start time"
                                [owlDateTime]="dt4"
                                [owlDateTimeTrigger]="dt4"
                                [(ngModel)]="start"
                                [min]="minDate"
                                (ngModelChange)="changeStartDateTime($event)"
                                aria-label="Select start time"
                                role="combobox"
                                aria-haspopup="dialog"
                                aria-controls="dt4-popup"
                                aria-expanded="false" />
                            <div
                                class="app-c-timepicker__icon"
                                tabindex="0"
                                role="button"
                                aria-label="Open time picker"
                                (click)="openTimer(dt4)"
                                (keydown.enter)="openTimer(dt4)"
                                (keydown.space)="openTimer(dt4)">
                                <svg-icon
                                    icon="clock"
                                    aria-hidden="true"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'timer'"
                                [stepMinute]="15"
                                [hour12Timer]="true"
                                #dt4
                                id="dt4-popup"></owl-date-time>
                        </div>
                    </div>
                </div>

                <!-- End Date & Time Blocks -->
                <div class="app-l-ss__line"></div>
                <div class="app-l-ss__blocks">
                    <!-- End Date -->
                    <div class="app-l-ss__block">
                        <label
                            for="endDateInput"
                            aria-label="Select end date"
                            class="app-c-body-text--14-m">
                            End Date</label
                        >
                        <div class="app-c-datepicker app-c-form-group">
                            <input
                                id="endDateInput"
                                class="app-c-form-control"
                                (ngModelChange)="changeEndDateTime($event)"
                                [owlDateTime]="dt2"
                                [owlDateTimeTrigger]="dt2"
                                placeholder="End Date"
                                [(ngModel)]="end"
                                [min]="start"
                                aria-label="Select end date" />
                            <div
                                class="app-c-datepicker__icon"
                                tabindex="0"
                                role="button"
                                aria-label="Open end date calendar"
                                (click)="dt2.open()"
                                (keydown.enter)="dt2.open()"
                                (keydown.space)="dt2.open()">
                                <svg-icon
                                    icon="calendar"
                                    aria-hidden="true"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'calendar'"
                                #dt2></owl-date-time>
                        </div>
                    </div>

                    <!-- End Time -->
                    <div class="app-l-ss__block">
                        <label
                            for="endTimeInput"
                            aria-label="Select end time"
                            class="app-c-body-text--14-m">
                            End Time</label
                        >
                        <div class="app-c-datepicker app-c-form-group">
                            <input
                                id="endTimeInput"
                                class="app-c-form-control"
                                [owlDateTimeTrigger]="dt5"
                                placeholder="End time"
                                [owlDateTime]="dt5"
                                [(ngModel)]="end"
                                (ngModelChange)="changeEndDateTime($event)"
                                aria-label="Select end time" />
                            <div
                                class="app-c-datepicker__icon"
                                tabindex="0"
                                role="button"
                                aria-label="Open end time picker"
                                (click)="dt5.open()"
                                (keydown.enter)="dt5.open()"
                                (keydown.space)="dt5.open()">
                                <svg-icon
                                    icon="clock"
                                    aria-hidden="true"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'timer'"
                                [stepMinute]="15"
                                [hour12Timer]="true"
                                #dt5></owl-date-time>
                        </div>
                    </div>
                </div>
            </div>

            <div class="date-error" *ngIf="!isEndDateValid" role="alert">
                <span class="app-c-body-text--14-m" translate>
                    as.endDateValidationMsg
                </span>
            </div>
        </div>
        <div class="app-l-select__schedule" *ngIf="activityId">
            <h4 class="app-c-heading--h4">
                <span>{{activity.title}}</span>
                <!-- <img
                    src="./assets/img/icons-svg/delete-button-icon.svg"
                    (click)="deleteActivity(activity.id)"
                /> -->
                <svg-icon
                    icon="delete-button-rounded"
                    (click)="deleteActivity(activity.id)"></svg-icon>
            </h4>
            <div class="app-l-ss__row">
                <div class="app-l-ss__blocks">
                    <div class="app-l-ss__block">
                        <label class="app-c-body-text--14-m"> Start Date</label>
                        <div class="app-c-datepicker app-c-form-group">
                            <input
                                class="app-c-form-control"
                                (ngModelChange)="changeStartDateTime($event)"
                                [owlDateTime]="dt1"
                                [owlDateTimeTrigger]="dt1"
                                placeholder="Start Date"
                                [(ngModel)]="start"
                                [min]="minDate" />
                            <div class="app-c-datepicker__icon">
                                <svg-icon icon="calendar"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'calendar'"
                                #dt1></owl-date-time>
                        </div>
                    </div>
                    <div class="app-l-ss__block">
                        <label class="app-c-body-text--14-m"> End Date</label>
                        <div class="app-c-datepicker app-c-form-group">
                            <input
                                class="app-c-form-control"
                                (ngModelChange)="changeEndDateTime($event)"
                                [owlDateTime]="dt2"
                                [owlDateTimeTrigger]="dt2"
                                placeholder="End Date"
                                [(ngModel)]="end"
                                [min]="start" />
                            <div class="app-c-datepicker__icon">
                                <svg-icon icon="calendar"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'calendar'"
                                #dt2></owl-date-time>
                        </div>
                    </div>
                </div>
                <!-- <div class="app-l-ss__line"></div> -->
                <div class="app-l-ss__blocks">
                    <div class="app-l-ss__block">
                        <label class="app-c-body-text--14-m"> Start Time</label>
                        <div class="app-c-timepicker app-c-form-group">
                            <input
                                class="app-c-form-control"
                                [owlDateTimeTrigger]="dt4"
                                [min]="minDate"
                                placeholder="Start time"
                                [owlDateTime]="dt4"
                                [(ngModel)]="start"
                                (ngModelChange)="changeStartDateTime($event)" />
                            <div class="app-c-timepicker__icon">
                                <svg-icon icon="clock"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'timer'"
                                [stepMinute]="15"
                                [hour12Timer]="true"
                                #dt4></owl-date-time>
                        </div>
                    </div>
                    <div class="app-l-ss__block">
                        <label class="app-c-body-text--14-m"> End Time</label>
                        <div class="app-c-datepicker app-c-form-group">
                            <input
                                class="app-c-form-control"
                                [owlDateTimeTrigger]="dt5"
                                placeholder="End time"
                                [owlDateTime]="dt5"
                                [(ngModel)]="end"
                                (ngModelChange)="changeEndDateTime($event)" />
                            <div class="app-c-datepicker__icon">
                                <svg-icon icon="clock"></svg-icon>
                            </div>
                            <owl-date-time
                                [pickerType]="'timer'"
                                [stepMinute]="15"
                                [hour12Timer]="true"
                                #dt5></owl-date-time>
                        </div>
                    </div>
                </div>
            </div>

            <div class="date-error" *ngIf="!isEndDateValid">
                <span class="app-c-body-text--14-m" translate
                    >as.endDateValidationMsg</span
                >
            </div>
        </div>
        <div class="app-l-checkbox">
            <label class="checkbox-label" translate>
                <input
                    type="checkbox"
                    class="check"
                    [(ngModel)]="isEmailInviteChecked" />
                as.calendarInviteEmail
            </label>
        </div>
        <!-- Footer -->
        <div class="app-c-modal-secondary__footer">
            <a
                class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                (click)="cancel()"
                (keydown.enter)="cancel()"
                (keydown.space)="cancel()"
                tabindex="0"
                role="button"
                aria-label="Cancel"
                translate>
                Cancel
            </a>
            <a
                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                *ngIf="!activityId"
                (click)="onSchedule()"
                [ngClass]="{ 'btn-disabled': !isEndDateValid }"
                (keydown.enter)="onSchedule()"
                (keydown.space)="onSchedule()"
                tabindex="0"
                role="button"
                aria-label="Schedule activity"
                translate>
                Schedule
            </a>
            <a
                class="app-c-btn app-c-btn--primary app-c-btn--curve"
                *ngIf="activityId"
                (click)="save()"
                [ngClass]="{ 'btn-disabled': !isEndDateValid }"
                (keydown.enter)="save()"
                (keydown.space)="save()"
                tabindex="0"
                role="button"
                aria-label="Save activity"
                translate>
                Save
            </a>
        </div>
    </div>
</div>
